export default __webpack_public_path__ + "static/media/cc5g.1ed17ca4.png";